const TRACK_ENDPOINT = '/.netlify/functions/track-event'

export const trackEvent = async (eventType, { propertyId = null, metadata = {}, token = null } = {}) => {
  if (!token) return
  try {
    await fetch(TRACK_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ eventType, propertyId, metadata }),
    })
  } catch {
    // fire-and-forget; silently swallow errors
  }
}
